<div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
<form *ngIf="!loading" [formGroup]="form" (ngSubmit)="onSubmit()" class="allurecare-form-main p-2">
    <mat-card class="" style="
    padding: 1rem 2rem;
">
        <!-- Operation Lines -->
        <div>
            <h5 class="mb-3 font-weight-bold">{{ 'dimbo.i18n.brandcareForm.subHeading.operationsLine' | translate }}</h5>

            <div class="grid-container">
                <!-- Conditions of Use -->
                <div class="grid-item" *ngIf="showConditionSwitch">
                    <div class="in-column-value">
                        <label>{{ 'dimbo.i18n.brandcareForm.label.conditionsOfUse' | translate }}</label>
                        <div class="d-flex ">
                            <ng-container>
                                <span class="mr-1">{{ 'dimbo.i18n.brandcareForm.switch.normal' | translate }}</span>
                                <mat-slide-toggle [checked]="form.get('conditionOfUse')?.value === 'Severe'"
                                                  (change)="onConditionOfUseToggle()" color="primary">
                                                  {{ 'dimbo.i18n.brandcareForm.switch.arduous' | translate }}
                                </mat-slide-toggle>
                              </ng-container>
                        </div>
                    </div>
                </div>

                <!-- Reference -->
                <div class="grid-item">
                    <div class="in-column-value">
                        <label>{{ 'dimbo.i18n.brandcareForm.label.reference' | translate }}</label>
                        <span>{{ form.get('reference')?.value }}</span>
                    </div>
                </div>

                <!-- Type of Service -->
                <div class="grid-item">
                    <div class="in-column-value">
                        <label>{{ 'dimbo.i18n.brandcareForm.label.typeOfService' | translate }}</label>
                        <span>{{ form.get('typeOfService')?.value }}</span>
                    </div>
                </div>

                <div class="grid-item" *ngIf="!showConditionSwitch">
                    <div class="in-column-value">
                    </div>
                </div>

                <!-- Maintenance Frequency -->
                <div class="grid-item">
                    <div class="in-column-value">
                        <label >{{ 'dimbo.i18n.brandcareForm.label.maintenanceFrequency' | translate }}</label>
                        <span>{{ form.get('maintenanceFrequency')?.value }}</span>
                    </div>
                </div>
            </div>
        </div>
        <mat-divider></mat-divider>

        <div *ngIf="isFlowPanier" class="grid-container-panier">
            <!-- Panier folder ID -->
            <div class="grid-item">
                <div [ngClass]="isMobile || isTablet ? 'in-column-value' : 'in-row-value'">
                    <label>{{ 'dimbo.i18n.brandcareForm.label.panierFolderId' | translate }}</label>
                    <span>{{ form.get('panierFolderId')?.value }}</span>
                </div>
            </div>

            <!-- DMS folder ID -->
            <div class="grid-item">
                <div [ngClass]="isMobile || isTablet ? 'in-column-value' : 'in-row-value'">
                    <label>{{ 'dimbo.i18n.brandcareForm.label.dmsFolderId' | translate }}</label>
                    <span>{{ form.get('dmsFolderId')?.value }}</span>
                </div>
            </div>
        </div>
        <mat-divider *ngIf="isFlowPanier"></mat-divider>
        <!-- Contract details -->
        <div>
            <h5 class="mb-3 font-weight-bold">{{ 'dimbo.i18n.brandcareForm.subHeading.contractDetails' | translate }}</h5>
            <div class="grid-container-contract mb-3">
                <!-- Vehicle Mileage -->
                <div class="d-flex align-items-center">
                    <div class="grid-item">
                        <div class="in-column-value">
                            <label >{{ 'dimbo.i18n.brandcareForm.label.vehicleMileage' | translate }}</label>
                            <div class="d-flex align-items-center">
                                <input class="underlined-input mr-2" type="number" formControlName="vehicleMileage"
                                    [ngClass]="{'is-invalid': hasError('vehicleMileage', 'required') || (submitted && form.get('vehicleMileage')?.value <= 0)}">
                                    <span *ngIf="form.get('mileageUnit')?.value?.toLowerCase() === 'mi'; else kmUnit">
                                        {{ 'dimbo.i18n.brandcareForm.unit.mi' | translate }}
                                      </span>
                                      <ng-template #kmUnit>
                                        {{ 'dimbo.i18n.brandcareForm.unit.km' | translate }}
                                      </ng-template>
                            </div>
                            <!-- Error message for vehicle mileage -->
                            <div class="error-message" *ngIf="hasError('vehicleMileage', 'required') && (form.get('vehicleMileage')?.value === '' || form.get('vehicleMileage')?.value === null)">
                                {{ 'dimbo.i18n.brandcareForm.error.vehicleMileageRequired' | translate }}
                            </div>
                            <div class="error-message" *ngIf="submitted && form.get('vehicleMileage')?.value !== '' && form.get('vehicleMileage')?.value !== null && form.get('vehicleMileage')?.value <= 0">
                                {{ 'dimbo.i18n.brandcareForm.error.vehicleMileagePositive' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid-item">
                    <div class="in-column-value">
                        <label >{{ 'dimbo.i18n.brandcareForm.label.vehicleAge' | translate }}</label>
                        <div>{{ form.get('vehicleAge')?.value }}&nbsp;{{ form.get('vehicleAge')?.value == 1 ? ('dimbo.i18n.brandcareForm.unit.month' | translate) : ('dimbo.i18n.brandcareForm.unit.months' | translate) }}</div>
                    </div>
                </div>
                <div class="grid-item">
                    <div class="in-column-value">
                        <label >{{ 'dimbo.i18n.brandcareForm.label.myLoginId' | translate }}</label>
                        <div>{{ form.get('loginId')?.value }}</div>
                    </div>
                </div>
            </div>

            <div class="grid-container-customer mt-2">
                <div class="grid-item">
                    <div class="in-column-value w-50">
                        <label >{{ 'dimbo.i18n.brandcareForm.label.customerEmail' | translate }}</label>
                        <input class="underlined-input" type="email" formControlName="customerEmail"
                            [ngClass]="{'is-invalid': hasError('customerEmail', 'required') || hasError('customerEmail', 'email') || hasError('customerEmail', 'pattern') || hasError('customerEmail', 'maxlength')}">
                        <!-- Error messages for customer email -->
                        <div class="error-message" *ngIf="hasError('customerEmail', 'required')">
                            {{ 'dimbo.i18n.brandcareForm.error.emailRequired' | translate }}
                        </div>
                        <div class="error-message" *ngIf="hasError('customerEmail', 'email') || hasError('customerEmail', 'pattern')">
                            {{ 'dimbo.i18n.brandcareForm.error.emailInvalid' | translate }}
                        </div>
                    </div>
                </div>
                <div class="grid-item">
                    <div class="in-column-value">
                        <label >{{ 'dimbo.i18n.brandcareForm.label.vehicleBrandWorkshopId' | translate }}</label>
                        <ng-container *ngIf="isFlowPanier; else hubWorkshopSelector">
                            <span>{{ form.get('repairerId')?.value }}</span>
                        </ng-container>
                        <ng-template #hubWorkshopSelector>
                            <ng-container *ngIf="vinRRDIList.length === 1; else vinRRDISelector">
                                <span>{{ vinRRDIList[0] }}</span>
                            </ng-container>
                            <ng-template #vinRRDISelector>
                                <mat-form-field class="w-100">
                                    <!-- <mat-label>Select workshop ID</mat-label> -->
                                    <mat-select formControlName="repairerId" required>
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let rrdi of vinRRDIList" [value]="rrdi">{{ rrdi }}</mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="form.get('repairerId')?.hasError('required')">
                                        {{ 'dimbo.i18n.brandcareForm.error.chooseWorkshopId' | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </ng-template>
                        </ng-template>
                        <!-- <ng-template #vinRRDISelector>
                            <mat-form-field appearance="fill" class="w-100">
                                <mat-label>Select workshop ID</mat-label>
                                <mat-select formControlName="repairerId" required>
                                    <mat-option value="">--</mat-option>
                                    <mat-option *ngFor="let rrdi of vinRRDIList" [value]="rrdi">{{ rrdi }}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.get('repairerId')?.hasError('required')">
                                    Please choose a workshop ID
                                </mat-error>
                            </mat-form-field>
                        </ng-template> -->
                    </div>
                </div>
            </div>
        </div>

        <div class=" my-3">
            <label class="custom-checkbox-label">
                <div class="checkbox-container">
                    <input type="checkbox" formControlName="confirmTerms" [ngClass]="{
                        'custom-checkbox': true,
                        'custom-error-checkbox': isCheckboxError('confirmTerms')
                      }" />
                </div>
                <span class="text-wrap" >
                    {{ 'dimbo.i18n.brandcareForm.checkbox.confirmTerms' | translate }}
                </span>
            </label>
            <div class="error-message" *ngIf="isCheckboxError('confirmTerms')">
                {{ 'dimbo.i18n.brandcareForm.error.confirmTerms.checkbox' | translate }}
            </div>
        </div>

        <div class="my-2">
            <label class="custom-checkbox-label">
                <div class="checkbox-container">
                    <input type="checkbox" formControlName="agreeTerms" [ngClass]="{
                        'custom-checkbox': true,
                        'custom-error-checkbox': isCheckboxError('agreeTerms')
                      }">
                </div>
                <span class="text-wrap" >
                    {{ 'dimbo.i18n.brandcareForm.checkbox.gdprTerms' | translate }}
                </span>
            </label>
            <div class="error-message" *ngIf="isCheckboxError('agreeTerms')">
                {{ 'dimbo.i18n.brandcareForm.error.agreeTerms.checkbox' | translate }}
            </div>
        </div>


    </mat-card>
    <!-- Buttons to cancel or Submit form -->
    <div class="d-flex justify-content-end mt-4">
        <button type="button" mat-stroked-button color="primary" class="mr-2" (click)="closeTab()">{{'dimbo.i18n.brandcareForm.button.cancel'
            | translate }}</button>
        <button type="submit" mat-flat-button color="primary" [disabled]="!form.get('repairerId')?.value">{{ 'dimbo.i18n.brandcareForm.button.submit' |
            translate}}</button>
    </div>
</form>